import React from "react";
import { Cause, Lesson } from "../../types/Lessons";
import { Box, Divider, List, ListItem } from "@mui/material";

const FishboneChart = (lesson: Lesson) => {
  const middle = Math.ceil(lesson.causes.length / 2);
  const topCauses = lesson.causes.slice(0, middle);
  const bottomCauses = lesson.causes.slice(middle);

  return <Box className="fishboneChart">
    <Box className="causes">
      <Box>{topCauses.map(cause => <Bone key={cause.category.id} cause={cause} position="top" /> )}</Box>
      <Divider />
      <Box>{bottomCauses.map(cause => <Bone key={cause.category.id} cause={cause} position="bottom" /> )}</Box>
    </Box>
    <Box className="effect">{lesson.headline}</Box>
  </Box>
};

const Bone = (props: { cause: Cause, position: "top" | "bottom" }) => {
  return <Box className="bone">
    { props.position == "top" && <Box className="category">{props.cause.category.name}</Box> }
    <Box className="issues">
      <List>
        {props.cause.issues.map(issue => <ListItem key={issue} disablePadding><small>{issue}</small></ListItem>)}
      </List>
      <Box className={`diagonal ${props.position == "top" ? "topBottom" : "bottomTop"}`}></Box>
    </Box>
    { props.position == "bottom" && <Box className="category">{props.cause.category.name}</Box> }
  </Box>
}

export default FishboneChart;